import React from 'react';
import { CardoGroup } from '@cotyorg/ccx-organism-cardo-group';
import {
  cyberbullyingStoriesCardsConfig,
  cyberbullyingStoriesNthCardsConfig,
} from './cardo.config';

export const CyberbullyingStoriesSection = () => (
  <div className="article-section article-section--padding-top">
    <div className="grid-container">
      <div className="grid-x grid-margin-x cyberbully-stories">
        <CardoGroup
          data="cyberbullyingStoriesCardoGroup"
          baseBreakpointConfig={cyberbullyingStoriesCardsConfig}
          everyNthBreakpointConfig={cyberbullyingStoriesNthCardsConfig}
          headingLevel={1}
        />
      </div>
    </div>
  </div>
);
